var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"white-slider"},[_c('input',{attrs:{"type":"range","min":_vm.min,"max":_vm.max,"step":_vm.step},domProps:{"value":_vm.value},on:{"input":_vm.inputChange,"change":_vm.handleChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }